import React from 'react';
import { Outlet, Navigate } from 'react-router';

const Protected = () => {
    const access_token = localStorage.getItem('accessToken')
    if (access_token) {
        return <Outlet />

    } else {
        return <Navigate to="/auth/login" replace={true} />
    }
}

export default Protected